// extracted by mini-css-extract-plugin
export var flip = "FeatureTable-module--flip--3xL1n";
export var row = "FeatureTable-module--row--3vMY7";
export var grid = "FeatureTable-module--grid--1-nHP";
export var title = "FeatureTable-module--title--3nqNP";
export var tierHiddenHeading = "FeatureTable-module--tier-hidden-heading--2x2Ji";
export var tierBorder = "FeatureTable-module--tier-border--1j5Hq";
export var tierHeading = "FeatureTable-module--tier-heading--2PdJR";
export var check = "FeatureTable-module--check--3Arw9";
export var feature = "FeatureTable-module--feature--2zFDJ";
export var toolTipWrap = "FeatureTable-module--tool-tip-wrap--1mh6-";
export var showTier = "FeatureTable-module--show-tier--21Sas";
export var hideTier = "FeatureTable-module--hide-tier--26LNL";